"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.exportLoginAudits = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _API = _interopRequireDefault(require("./API"));

var _requestSelectors = require("./requestSelectors");

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var exportLoginAudits = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.exportLoginAudits,
  initiatingActionType: _actions.LoginAuditApiActionTypes.EXPORT,
  requestStatusSelector: _requestSelectors.getExportLoginAuditsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.ExportLoginAudits
}));
exports.exportLoginAudits = exportLoginAudits;

var _default = (0, _reduxObservable.combineEpics)(exportLoginAudits);

exports.default = _default;